import Channels from './channels';
import Channel from './channel';

export default Channels;
export { Channel, Channels };
export {
  CHANNEL_TYPE_LABELS,
  CHANNEL_RUNTIME_STATUS_COLORS,
  CHANNEL_RUNTIME_STATUS_LABELS,
  createChannel,
  deleteChannel,
  getChannel,
  getChannels,
  getChannelRuntimeStatusColor,
  getChannelRuntimeStatusLabel,
  getChannelTypeLabel,
  updateChannel,
} from './channels';
